'use client'
import { Row } from '@repo/ui/components'
import { LogoTypeBrand } from '../../components'

export const SimpleHeaderLayout = () => {
  return (
    <div className='sticky top-0 w-full z-10 '>
      <div className='flex mx-auto p-2  items-center gap-4'>
        <Row className='relative mx-auto w-[5.25rem] aspect-[3/1]'>
          <LogoTypeBrand
            alt='logo'
            fill
            className='object-contain'
            sizes='(max-width: 768px) 100vw, 5.25rem'
            priority
          />
        </Row>
      </div>
    </div>
  )
}
